import React, { useEffect } from "react";
import ServiceSender from "../components/service/ServiceSender";
import Navbar from "../common/Navbar";
import Footer from "../common/Footer";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
const ServiceSms = () => {
  const location = useLocation();
  useEffect(() => {
    const { search } = location;
    if (!search) {
      window.scroll(0, 0);
    }
  }, []);
  return (
    <>
      <Helmet>
        <meta
          name="keywords"
          content="Best bulk SMS company,
                  Bulk SMS gateway provider,
                  Bulk SMS India,
                  Bulk SMS marketing in Chennai,
                  DLT approved bulk SMS provider,
                  Transactional bulk SMS,
                  Affordable bulk SMS service in Chennai,
                  Bulk SMS for small businesses,
                  Bulk SMS service in Chennai,
                  Bulk SMS provider near me,
                  Nearby DLT-approved bulk SMS service,
                  Bulk SMS API for PHP/Java/.NET,
                  SMS API with OTP support,
                  Bulk SMS with Unicode/multilingual support,
                  bulk sms messaging services,
                  bulk sms service in Chennai,
                  bulk sms service provider in Chennai,
                  Bulk SMS services Chennai,
                  Affordable bulk SMS provider in Chennai,
                  SMS API Integration,
                  OTP SMS Gateway in Chennai,
                  Promotional SMS Services in Chennai,
                  Bulk SMS Service Provider,
                  DLT-Approved SMS Gateway Provider India,
                  Bulks SMS Company in Chennai,
                  bulk sms service in Chennai,
                  bulk sms service in India,
                  best bulk sms provider in Chennai,
                  best bulk sms provider in India,
                  promotional sms service Chennai,
                  promotional sms service India,
                  transactional sms service Chennai,
                  transactional sms service India,
                  bulk sms for business promotion Chennai,
                  bulk sms for business promotion India,
                  sms marketing company Chennai,
                  sms marketing company India,
                  sms gateway provider in India,
                  cheap bulk sms Chennai,
                  cheap bulk sms India,
                  business sms marketing Chennai,
                  business sms marketing India,
                  Sender ID SMS in Chennai,
                  Sender ID SMS in India,
                  DLT SMS in Chennai,
                  DLT SMS in India,
                  SMS campaign service in Chennai,
                  SMS campaign service in India"
        />
        <title>SMS Marketing & SMS Service for Business Growth</title>
        <meta
          name="description"
          content="Boost engagement with professional SMS marketing and reliable SMS service. DLT-approved sender IDs, APIs, analytics, and high delivery rates."
        />
      </Helmet>

      <div>
        <Navbar />
        <ServiceSender />
        <Footer />
      </div>
    </>

  );
};

export default ServiceSms;
